module.exports = require("plugin-liverig/shared/asset/hooks/RouteContext");